import styled from 'styled-components'
import { Menu } from 'antd'

export const StyledMenu = styled(Menu)`
  min-height: calc(100vh - 160px);
`
export const StyledTab = styled.div`
    .ant-tabs-tab{
         color: #ffffff;
    } 
`


// WEBPACK FOOTER //
// ./src/components/list-menu/style.js